// test1948
(1948 && 0);
